module.exports = __webpack_public_path__ + "img/thigh.a82c12a0.png";